import englishPageData from './english/englishPageData';
import spanishPageData from './spanish/spanishPageData';
import frenchPageData from './french/frenchPageData';
import germanPageData from './german/germanPageData';
import italianPageData from './italian/italianPageData';

export const STATIC_LANGUAGE_PAGES = [
  englishPageData,
  spanishPageData,
  frenchPageData,
  germanPageData,
  italianPageData,
];
